<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />

  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'

export default {
  name: 'AdminDashboard',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  mounted () {
    core.index()
  }
}
</script>
